import {colorVehicleState, colorSpeedState} from '../utils/stateColors'

export const vehicleStatesMixin = {
  data: function() {
    return {
      amountStoppedTime: 0,
      changeStateAt: ''
    }
  },
  methods: {
    stateColor(vehicle) {
      if (vehicle === null) {
        const data = {
          color: '#E0E0E0',
          changeStateAt: 'cargando...',
          amountStoppedTime: 'cargando...',
          stoppedSince: 'cargando...',
          indexState: 'cargando...'
        }
        return data
      }
      // if (vehicle.id === 1676) console.log('SAMPLE MIXIN: ', vehicle, vehicle.stoppedTimeSinceV2)
      // if (vehicle.id === 528) console.log('SAMPLE MIXIN 528: ', vehicle.initialStoppedTimeVerbose)
      // if (vehicle.id === 1481) console.log('SAMPLE MIXIN 1481: ', vehicle.initialStoppedTimeVerbose)
      // console.log('- - - - - vehicle :', vehicle)
      // let stoppedTime = vehicle.stoppedTime
      // let initialStoppedTime = vehicle.initialStoppedTime
      // let initialStoppedTime = vehicle.initialStoppedTimeVerbose
      let initialStoppedTime = vehicle.stoppedTimeSinceV2
      // const inMovement = vehicle.initialStoppedTime === ''
      const inMovement = vehicle.stoppedTimeSinceV2 === ''
      const staticVehicle = vehicle.stoppedTimeSinceV2 === 'static'
      // console.log('IN MOVEMENT: ', inMovement, vehicle.initialStoppedTime)
      // const speed = vehicle.location.speed
      // console.log(' *** *** *** *** *** initialStoppedTime: ', initialStoppedTime)

      const now = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      // console.log('NOW: ', now)

      let stoppedRealTime = 0
      // const istime = this.$moment(initialStoppedTime)
      const istime = initialStoppedTime
      if (initialStoppedTime) {
        // const sit = this.$moment(istime).format('YYYY-MM-DD HH:mm:ss')
        const sit = istime
        // console.log(' --- --- --- --- sit: ', sit)
        stoppedRealTime = this.$moment(now).diff(sit, 'minutes')
        // stoppedRealTime = this.$moment.duration(sit.diff(now))
      }

      // console.log(' +++ +++ +++ stoppedRealTime: ', stoppedRealTime)
      const stoppedTime = stoppedRealTime

      let stateNumber = 0
      let initialStoppedTimeDate = 'NA'
      let addMinutes = 0

      if (inMovement) {
        const data = {
          color: colorSpeedState['SPEED_0'],
          changeStateAt: 'NA',
          amountStoppedTime: 0,
          stoppedSince: 'NA',
          indexState: 'En Movimiento'
        }
        return data
      } else if (staticVehicle) {
        const data = {
          color: colorVehicleState['STATE_9'],
          changeStateAt: 'Estático',
          amountStoppedTime: 'Estático',
          stoppedSince: 'Estático',
          indexState: 9
        }
        return data
      } else {
        // console.log('stoppedTime: ', stoppedTime)
        switch (true) {
          case (stoppedTime < 15):
            stateNumber = 0
            addMinutes = 0
            break
          case (stoppedTime >= 15 && stoppedTime < 30):
            stateNumber = 1
            addMinutes = 15
            break
          case (stoppedTime >= 30 && stoppedTime < 60):
            stateNumber = 2
            addMinutes = 30
            break
          case (stoppedTime >= 60 && stoppedTime < 120):
            stateNumber = 3
            addMinutes = 60
            break
          case (stoppedTime >= 120 && stoppedTime < 240):
            stateNumber = 4
            addMinutes = 120
            break
          case (stoppedTime >= 240 && stoppedTime < 480):
            stateNumber = 5
            addMinutes = 240
            break
          case (stoppedTime >= 480 && stoppedTime < 1440):
            stateNumber = 6
            addMinutes = 480
            break
          case (stoppedTime >= 1440 && stoppedTime < 4320):
            stateNumber = 7
            addMinutes = 1440
            break
          case (stoppedTime >= 4320 && stoppedTime < 43200):
            stateNumber = 8
            addMinutes = 4320
            break
          case (stoppedTime >= 43200):
            stateNumber = 9
            addMinutes = 43200
            break
          default:
            stateNumber = 0
            addMinutes = 0
            break
        }
        initialStoppedTimeDate = this.$moment(istime).add(addMinutes, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        // console.log(' |||||||||||||||| initialStoppedTimeDate: ', initialStoppedTimeDate)
      }
      const data = {
        color: colorVehicleState['STATE_' + stateNumber],
        changeStateAt: initialStoppedTimeDate,
        amountStoppedTime: stoppedTime,
        stoppedSince: vehicle.stoppedTimeSinceV2,
        indexState: stateNumber
      }
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/vehicleStatesMixin.js